export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
